// extracted by mini-css-extract-plugin
export var dropdownButton = "_2i-0";
export var fullWidthDropdownButton = "_2i-1";
export var icon = "_2i-3";
export var iconPlaceholder = "_2i-2";
export var menuItemRow = "_2i-9";
export var separator = "_2i-e";
export var shortcutContainer = "_2i-7";
export var shortcutContainerFilled = "_2i-8";
export var shortcutIconLg = "_2i-6";
export var shortcutIconMd = "_2i-5";
export var shortcutIconSm = "_2i-4";
export var submenuChevron = "_2i-d";
export var submenuDropdown = "_2i-a";
export var submenuTriggerRow = "_2i-b";
export var submenuTriggerRowOpen = "_2i-c";